<template>
  <div class="upload-container">
    <!--<el-button icon="el-icon-upload" size="mini" :style="{ background : color, borderColor : color }"-->
               <!--@click="dialogVisible = true" type="primary" >上传图片-->
    <!--</el-button>-->
    <el-dialog append-to-body :visible.sync="dialogVisible" center title="上传图片">
      <el-upload class="editor-slide-upload"
                 :action="uploadUrl"
                 :headers="uploadHeader"
                 :multiple="true"
                 :file-list="fileList"
                 :show-file-list="true"
                 list-type="picture-card"
                 :on-remove="handleRemove"
                 :on-success="handleSuccess"
                 :before-upload="beforeUpload">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <slot name="footer">
          <el-button plain type="success" @click="handleSubmit">确 定</el-button>
          <el-button plain type="warning" @click="dialogVisible = false">取 消</el-button>
        </slot>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import { getToken } from 'api/qiniu'

  export default {
    name: 'editorSlideUpload',
    props: {
      color: {
        type: String,
        default: '#1890ff'
      }
    },
    data() {
      return {
        dialogVisible: false,
        listObj: {},
        fileList: []
      }
    },
    computed: {
      uploadUrl() {
        return SZH.assets.api + '/File/PostNewsImage'
      },
      uploadHeader() {
        var token = localStorage.ms_token;
        return {
          Authorization: 'Bearer ' + token
        }
      }
    },
    methods: {
      checkAllSuccess() {
        return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
      },
      handleSubmit() {
        const arr = Object.keys(this.listObj).map(v => this.listObj[v])
        if (!this.checkAllSuccess()) {
          this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
          return
        }
        this.$emit('successCBK', arr)
        this.listObj = {}
        this.fileList = []
        this.dialogVisible = false
      },
      handleSuccess(response, file, fileList) {
        if (response && response.State == 1) {
          const uid = file.uid
          const objKeyArr = Object.keys(this.listObj)
          for (let i = 0, len = objKeyArr.length; i < len; i++) {
            if (this.listObj[objKeyArr[i]].uid === uid) {
              this.listObj[objKeyArr[i]].url = SZH.assets.image + response.Data
              this.listObj[objKeyArr[i]].hasSuccess = true
              return
            }
          }
        }
      },
      handleRemove(file) {
        const uid = file.uid
        const objKeyArr = Object.keys(this.listObj)
        for (let i = 0, len = objKeyArr.length; i < len; i++) {
          if (this.listObj[objKeyArr[i]].uid === uid) {
            delete this.listObj[objKeyArr[i]]
            return
          }
        }
      },
      beforeUpload(file) {
        const _self = this
        const _URL = window.URL || window.webkitURL
        const fileName = file.uid

        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'|| file.type === 'image/gif';
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          _self.$message.error('上传的图片只能是 JPG 或 PNG 格式!');
        }
        else if (!isLt2M) {
          _self.$message.error('上传的图片大小不能超过 10MB!');
        }
        else{
          _self.listObj[fileName] = {}
        }

        return isJPG && isLt2M ? new Promise((resolve, reject) => {
          const img = new Image()
          img.src = _URL.createObjectURL(file)
          img.onload = () => {
            _self.listObj[fileName] = {
              hasSuccess: false,
              uid: file.uid,
              width: this.width,
              height: this.height
            }
          }
          resolve(true)
        }) : false;
      }
    }
  }

</script>

<style scoped>
  .editor-slide-upload {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/tycomponents/Editor/components/EditorImage.vue